import React from 'react';
import getIncludedResponse from '../../../../helpers/getIncludedResource';
import { actions as screeningActions } from '../../redux/screeningActions';
import { connect, useSelector } from 'react-redux';
import ButtonBar from '../ButtonBar';
import { Col, Row } from 'react-bootstrap';
import { Button } from '../../../../common/components';
import './DeclaredConditions.scss';
const Conditions = ({ conditions }) => {
  return (
    <div className={'declared-conditions--list'}>
      <span className={'declared-conditions--first-condition'}>{conditions[0]}</span>
      {conditions.length > 1 && (
        <span className={'linked-conditions'}>{conditions.slice(1).join(', ')}</span>
      )}
    </div>
  );
};

const Buttons = ({
  isDeleting,
  isEditing,
  declaration,
  onEditDeclaration,
  onDeleteDeclaration,
}) => {
  const handleEdit = () => {
    onEditDeclaration(declaration.id);
  };

  const handleDelete = () => {
    onDeleteDeclaration(declaration.attributes.group, declaration.attributes.conditions?.join(', '));
  };

  return (
    <ButtonBar>
      <Button
        label="Remove"
        size="sm"
        bsStyle={'default'}
        className="pull-right"
        isLoading={isDeleting === declaration.id}
        handleClick={handleDelete}
      />
      <Button
        label="Edit"
        size="sm"
        bsStyle={'secondary'}
        className="pull-right"
        isLoading={isEditing === declaration.id}
        handleClick={handleEdit}
      />
    </ButtonBar>
  );
};

const DeclaredConditions = ({ onDeleteDeclaration, onEditDeclaration }) => {
  const { isEditing, isDeleting, declaredConditions } = useSelector(
    (state) => state.screening,
  );

  const screenedDeclaredConditions =
    getIncludedResponse(
      declaredConditions.data,
      declaredConditions.included,
      'conditions',
    ) || [];

  return (
    <div className="declared-conditions">
      {screenedDeclaredConditions.length
        ? screenedDeclaredConditions.map((declaration, declarationIndex) => {
            return (
              <Row key={declarationIndex} className={'condition'}>
                <Col sm={8}>
                  <div className={'conditions'}>
                    <Conditions conditions={declaration.attributes.conditions} />
                  </div>
                </Col>

                <Col sm={4}>
                  <Buttons
                    declaration={declaration}
                    isEditing={isEditing}
                    isDeleting={isDeleting}
                    onDeleteDeclaration={onDeleteDeclaration}
                    onEditDeclaration={onEditDeclaration}
                  />
                </Col>
              </Row>
            );
          })
        : null}
    </div>
  );
};
export default connect(
  null,
  {
    onEditDeclaration: screeningActions.editDeclaration,
    onDeleteDeclaration: screeningActions.deleteDeclaration,
  },
)(DeclaredConditions);
